
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lyziarske-strediska-v-okoli",
      function () {
        return require("private-next-pages/lyziarske-strediska-v-okoli.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lyziarske-strediska-v-okoli"])
      });
    }
  